/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FileTypeEnum } from './FileTypeEnum';
import {
    FileTypeEnumFromJSON,
    FileTypeEnumFromJSONTyped,
    FileTypeEnumToJSON,
    FileTypeEnumToJSONTyped,
} from './FileTypeEnum';

/**
 * Serializer for the EpaFormFile model.
 * @export
 * @interface EpaFormFileCreateRequest
 */
export interface EpaFormFileCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof EpaFormFileCreateRequest
     */
    file: string;
    /**
     * 
     * @type {FileTypeEnum}
     * @memberof EpaFormFileCreateRequest
     */
    fileType: FileTypeEnum;
}



/**
 * Check if a given object implements the EpaFormFileCreateRequest interface.
 */
export function instanceOfEpaFormFileCreateRequest(value: object): value is EpaFormFileCreateRequest {
    if (!('file' in value) || value['file'] === undefined) return false;
    if ((!('fileType' in (value as Record<string, any>)) && !('file_type' in (value as Record<string, any>))) || ((value as Record<string, any>)['fileType'] === undefined && (value as Record<string, any>)['file_type'] === undefined)) return false;
    return true;
}

export function EpaFormFileCreateRequestFromJSON(json: any): EpaFormFileCreateRequest {
    return EpaFormFileCreateRequestFromJSONTyped(json, false);
}

export function EpaFormFileCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): EpaFormFileCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'file': json['file'],
        'fileType': FileTypeEnumFromJSON(json['file_type']),
    };
}

export function EpaFormFileCreateRequestToJSON(json: any): EpaFormFileCreateRequest {
    return EpaFormFileCreateRequestToJSONTyped(json, false);
}

export function EpaFormFileCreateRequestToJSONTyped(value?: EpaFormFileCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'file': value['file'],
        'file_type': FileTypeEnumToJSON(value['fileType']),
    };
}

